import classNames from 'classnames';
import React from 'react';
import IconZoom from './icon-zoom';
import IconMagnifyingGlass from './icon-magnifying-glass';
import IconMenu from './icon-menu';
import IconClose from './icon-close';
import IconCloseCircle from './icon-close-circle';
import IconCaret from './icon-caret';
import IconArrow from './icon-arrow';
import IconFacebook from './icon-facebook';
import IconTwitter from './icon-twitter';
import IconInstagram from './icon-instagram';
import IconDribbble from './icon-dribbble';
import IconLinkedin from './icon-linkedin';
import IconCaretThin from './icon-caret-thin';
import IconGithub from './icon-github';
import IconThreads from './icon-threads';
import IconHome from './icon-home';
import IconDashboard from './icon-dashboard';
import IconSellCloud from './icon-sellCloud';
import IconGraph5 from './icon-graph5';
import IconMystery from './icon-mystery';
import IconPhotoLibrary from './icon-photoLibrary';
import IconFamiliarFace from './icon-familiarFace';
import IconRoute from './icon-route';
import IconTactic from './icon-tactic';
import { IconDeployedCode } from './icon-deployedCode';
import IconLabProfile from './icon-labProfile';
import IconAccountBalance from './icon-accountBalance';
import IconGroup3 from './icon-group3';

const IconMap = {
    caret: IconCaret,
    caretThin: IconCaretThin,
    'close-circle': IconCloseCircle,
    menu: IconMenu,
    close: IconClose,
    'magnifying-glass': IconMagnifyingGlass,
    zoom: IconZoom,
    arrow: IconArrow,
    facebook: IconFacebook,
    twitter: IconTwitter,
    instagram: IconInstagram,
    dribbble: IconDribbble,
    linkedin: IconLinkedin,
    github: IconGithub,
    threads: IconThreads,
    home: IconHome,
    dashboard: IconDashboard,
    'sell-cloud': IconSellCloud,
    graph5: IconGraph5,
    mystery: IconMystery,
    photoLibrary: IconPhotoLibrary,
    familiarFace: IconFamiliarFace,
    route: IconRoute,
    tactic: IconTactic,
    labProfile: IconLabProfile,
    accountBalance: IconAccountBalance,
    group3: IconGroup3,
    deployedCode: IconDeployedCode,
};

type IconProps = {
    // contentful type is string, can't use keyof
    // name: keyof typeof IconMap;
    name: string;
    color?: 'white' | 'black' | 'chartreuse';
    size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl';
    direction?: 'up' | 'down' | 'left' | 'right';
};

/*
    Wrapper component for all icon
        - Icon must be black for filter to work
    Add a new Icon:
        - create icon component and aria-hidden
        - Add to IconMap above
        - Add icon to icon.stores in libs/ui/design-system
        -
    Add new color: Add filter class to filters.css. Calculate filter by using one of these:
        - https://codepen.io/sosuke/pen/Pjoqqp
        - https://tailwind-color-filter-generator.vercel.app/

*/
export const Icon = (props: IconProps) => {
    const { color = 'black', name, size = 'base', direction = 'right' } = props;
    if (!name) {
        console.error('Icon name is required');
    }

    const sizeClass = classNames({
        'w-4 h-4': size === 'sm',
        'w-6 h-6': size === 'base',
        'w-7 h-7': size === 'lg',
        'w-10 h-10': size === 'xl',
        'w-11 h-11': size === '2xl',
    });

    const filterClass = classNames({
        'filter-chartreuse': color === 'chartreuse',
        'filter-white group-hover:filter-chartreuse': color === 'white',
        'filter-black': color === 'black',
    });

    const directionClass = classNames({
        'rotate-90': direction === 'down',
        'rotate-180': direction === 'left',
        'rotate-270': direction === 'up',
    });

    const IconComponent = IconMap[name as keyof typeof IconMap];

    return (
        <span className={`${filterClass} ${sizeClass} ${directionClass} origin-center inline-block transition-all`}>
            {/* in some instances the svg needs the specific size and not full width and height */}
            <IconComponent />
        </span>
    );
};

export default Icon;
